import { gql } from '@apollo/client';

const OvertimeProjectFragment = gql`
  fragment OvertimeProject on Project {
    id

    name
    description
    additionalName
    draft
    hsProjectNumber
    projectNumber
  }
`;

export default OvertimeProjectFragment;
